import classes from "./DetailsPage.module.css";
import { IconButton, Tooltip } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

type DetailsPageProps = {
    handleCloseModal: () => void;
  };

const DetailsPage: React.FC<DetailsPageProps> = (props) => {
    return(
        <div className={classes["top-section"]}>
            <div className={classes["title-section"]}>
              <div className={classes["modal-title"]}>
                Details
              </div>
            </div>
            <div className={classes["tools-section"]}>
              <div>
              <Tooltip title="Close">
                <IconButton
                  aria-label="Close"
                  size="small"
                  onClick={props.handleCloseModal}
                >
                  <CloseIcon />
                </IconButton>
              </Tooltip>
              </div>
            </div>
          </div>
    )
}

export default DetailsPage;